import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {catchError, Observable, tap, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PrinterCategoryQueueAssignmentDto} from "../../shared/models/printer-category-queue-assignment-dto";
import {PrinterDto} from "../../shared/models/printer-dto";
import {FrontendError} from "../../shared/models/FrontendError";

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  private baseUrlService = environment.apiUrl;
  private baseUrlErrors = this.baseUrlService + 'errors';

  constructor(private http: HttpClient, private _snackBar: MatSnackBar) { }

  createError(frontendError: FrontendError): Observable<any> {
    return this.http.post<any>(`${this.baseUrlErrors}`, frontendError).pipe(
      tap(_ => this.log('post frontend error')),
      catchError(this.handleError<FrontendError[]>('create frontend error', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      this._snackBar.open('Es ist ein Fehler aufgetreten.', 'Schließen', {duration: 3000});

      // Let the app keep running by returning an empty result.
      return throwError(() => error); //of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(`OrderService: ${message}`);
  }
}
